import React, { useState, useEffect } from "react";
import { useRouteMatch, useLocation } from "react-router-dom";
import { Button, Modal, Tooltip, Row, Tag, Col } from "antd";
import { VideoCameraOutlined, CloseOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { checkMob } from "lib/utils/helperMethods";
import VideoCall from "lib/VideoCall/VideoCall";
import {
  studentVideoCallConfig,
  teacherVideoCallConfig,
} from "lib/VideoCall/config";
import { useSelector } from "react-redux";
import { currentUserSelector } from "views/Auth/Login/selector";
import { experienceViewModeSelector } from "views/Experiences/selector";
import { useTranslate } from "lib/MrTranslate/MrTranslate";

const VideoCallWrapper = (props) => {
  const mrIntl = useTranslate()
  const { url, path } = useRouteMatch();
  const location = useLocation();
  const { videoCallUUID } = props;
  console.log("VideoCallWrapper props", url, path, location);
  const isMobile = checkMob();
  const currentUser = useSelector(currentUserSelector());
  // const [visible, setVisible] = useState(minimized ? false : true);
  const [visible, setVisible] = useState(true);
  const [muteAction, setMuteAction] = useState(false);
  const [position, setPosition] = useState(false);
  const experienceViewMode = useSelector(experienceViewModeSelector()); 

  let videoCallConfig, containerDimensions, configOverrides
  let showToggleButton = false
  if(experienceViewMode == "apTakeTest" || experienceViewMode == "apPreviewTest"){
    showToggleButton = true
    videoCallConfig = studentVideoCallConfig
    containerDimensions = {
      // width: "1000px"
      width: "100%",
      height: "100%",
    }
    configOverrides = {
      width: "100%",
      height: "100%"
    }
  }else{
    videoCallConfig = teacherVideoCallConfig
    containerDimensions = {
      // width: "1000px"
      width: "100%",
      height: "700px",
    }
    configOverrides = {
      width: "100%",
      height: "700px"
    }
  }

  let finalConfig = {
    roomName: `AssessPrep-${videoCallUUID.substring(0, 10)}`,
    userInfo: {
      email: currentUser.email,
      displayName: currentUser.name,
    },
    ...configOverrides,
    ...videoCallConfig,
  }

  let videoCallProps = {
    containerDimensions: containerDimensions,
    config: finalConfig
  }
  if(experienceViewMode == "apTakeTest"){
    videoCallProps.muteAction = muteAction
    // need this to mute student mic on close
  }

  let videoRender = videoCallUUID && (
    <>
      <VideoCall
        {...videoCallProps}
        // containerDimensions={containerDimensions}
        // config={finalConfig}
        // muteAction={muteAction}
      />
    </>
  );

  let className = `jitsi-student-video ${visible ? "full-screen" : ""} ${
    isMobile ? "mobile" : ""
  }`;

  return (
    <div className={"video-call-wrapper"} >
      <div className={experienceViewMode == "apTakeTest" || experienceViewMode == "apPreviewTest" ? className : ""}>
        {/* mini iframe */}
        {/* {visible && (
          <Button
            className="close-button"
            ghost={true}
            icon={<CloseOutlined />}
            onClick={() => {
              // setPosition(true);
              setVisible(false);
              setMuteAction(false);
            }}
          >
            Close
          </Button>
        )} */}
        {videoRender}
      </div>

      {showToggleButton && <div className="video-call-button-wrapper">
        {/* <Tooltip title="Video call" placement="bottom"> */}
          <Button
            className="video-call-button"
            // style={{position: position && 'relative', right: position && '115px'}}
            shape="round"
            // type="primary"
            size={"large"}
            // ghost={true}
            icon={visible ? <CloseCircleOutlined />  : <VideoCameraOutlined />}
            onClick={() => {
              if(visible){
                // close action
                // on student close, mute the mic otherwise left unmuted - triggering a change in muteAction on open and close so that it checks and mutes if not muted
                setVisible(false);
                setMuteAction(false);
              }else{
                setVisible(true);
                setMuteAction(true);
              }
            }}
          >
            {/* {isMobile ? "" : <MrTranslate id={"VideoCallWrapper.video"}/>}/ */}
            {isMobile ? "" : mrIntl("VideoCallWrapper.video")}

          </Button>
        {/* </Tooltip> */}
        </div>
      } 
     
    </div>
  );
};

export default VideoCallWrapper;
